import React from 'react';
import { motion } from 'framer-motion';
const coaches = [{
  name: 'Marcus Thorne',
  title: 'Head Coach / Kru',
  record: '32-8-0 (14 KO)',
  image: 'https://images.unsplash.com/photo-1517438322307-e67111335449?q=80&w=2942&auto=format&fit=crop',
  bio: 'Fought out of Bangkok for 6 years. Rajadamnern Stadium veteran. Specializes in heavy clinch work and aggressive forward pressure.'
}, {
  name: 'Sarah Jenkins',
  title: 'Striking Coach',
  record: '18-4-0 (6 KO)',
  image: 'https://images.unsplash.com/photo-1622599511051-16f55a1234d0?q=80&w=2944&auto=format&fit=crop',
  bio: 'Current regional champion. Known for devastating teeps and technical counter-striking. Leads the competition prep team.'
}];
export function Coaches() {
  return <section id="coaches" className="py-24 bg-zinc-900 border-y border-zinc-800" data-id="element-10">
      <div className="container mx-auto px-6" data-id="element-11">
        <div className="mb-16" data-id="element-12">
          <h2 className="font-display text-5xl md:text-7xl text-white uppercase mb-4" data-id="element-13">
            The <span className="text-red-600" data-id="element-14">Corner</span>
          </h2>
          <p className="text-zinc-400 text-lg max-w-2xl" data-id="element-15">
            Learn from those who have made the walk. Our coaches aren't just pad
            holders; they are seasoned fighters with real ring experience.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-5xl" data-id="element-16">
          {coaches.map((coach, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="group" data-id="element-17">
              <div className="relative aspect-[4/5] mb-6 overflow-hidden bg-zinc-800" data-id="element-18">
                <img src={coach.image} alt={coach.name} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 scale-105 group-hover:scale-100" data-id="element-19" />
                <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-transparent to-transparent opacity-80" data-id="element-20" />
                <div className="absolute bottom-0 left-0 p-6" data-id="element-21">
                  <div className="text-red-600 font-display tracking-widest text-sm mb-1 uppercase" data-id="element-22">
                    {coach.title}
                  </div>
                  <h3 className="font-display text-4xl text-white uppercase" data-id="element-23">
                    {coach.name}
                  </h3>
                </div>
              </div>

              <div className="flex items-center gap-4 mb-4" data-id="element-24">
                <span className="bg-zinc-800 text-zinc-300 text-xs font-bold px-3 py-1 uppercase tracking-wider" data-id="element-25">
                  Pro Record: {coach.record}
                </span>
              </div>

              <p className="text-zinc-400 leading-relaxed" data-id="element-26">{coach.bio}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}